// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider {
  margin-left: 16px;
  margin-right: 16px;
  width: 90%;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bar {
  background: #ffe4d1;
  height: 2px;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-selection {
  background: rgb(43, 0, 255);
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-pointer {
  width: 8px;
  height: 16px;
  top: auto; /* to remove the default positioning */
  bottom: 0;
  background-color: #333;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-pointer:after {
  display: none;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bubble {
  bottom: 14px;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bubble.ngx-slider-limit {
  color: orange;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-tick {
  width: 1px;
  height: 10px;
  margin-left: 4px;
  border-radius: 0;
  background: black;
  top: -1px;
}
::ng-deep .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected {
  background: orange;
}

.pixelSpacing-input-box {
  width: 70px;
  margin-left: 20px;
  margin-right: 10px;
}

.available-checkbox {
  margin-top: 15px;
  margin-bottom: 12px;
}

.nbia-pixelSpacing-range-note {
  padding-top: 0;
  margin-top: 4px;
  margin-bottom: 10px;
  margin-left: 36px;
  height: 20px;
}

.nbia-pixelSpacing-range-update-button {
  float: right;
  margin-right: 10px;
  margin-bottom: 10px;
  height: 30px;
  padding-top: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/image-search/query-section/query-section-tabs/images-search-tab/images-pixel-spacing-search/images-pixel-spacing-search.component.scss"],"names":[],"mappings":"AAGI;EAGI,iBAAA;EACA,kBAAA;EACA,UAAA;AAJR;AAOI;EACE,mBAAA;EACA,WAAA;AALN;AAOI;EACE,2BAAA;AALN;AAQI;EACE,UAAA;EACA,YAAA;EACA,SAAA,EAAA,sCAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AANN;AASI;EACE,aAAA;AAPN;AAUI;EACE,YAAA;AARN;AAWI;EAEE,aAAA;AAVN;AAaI;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AAXN;AAcI;EACE,kBAAA;AAZN;;AAgBE;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AAbJ;;AAgBE;EACE,gBAAA;EACA,mBAAA;AAbJ;;AAiBA;EAEE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,YAAA;EACA,kBAAA;EAEA,mBAAA;EACA,YAAA;EACA,gBAAA;AAhBF","sourcesContent":["// need to use ::ng-deep to overcome view encapsulation\n::ng-deep {\n\n    .nbia-pixelSpacing-range-slider .ngx-slider {\n        // padding-left: 16px;\n        // padding-right: 16px;\n        margin-left: 16px;\n        margin-right: 16px;\n        width: 90%;\n      }\n\n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bar {\n      background: #ffe4d1;\n      height: 2px;\n    }\n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-selection {\n      background: rgb(43, 0, 255);\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-pointer {\n      width: 8px;\n      height: 16px;\n      top: auto; /* to remove the default positioning */\n      bottom: 0;\n      background-color: #333;\n      border-top-left-radius: 3px;\n      border-top-right-radius: 3px;\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-pointer:after {\n      display: none;\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bubble {\n      bottom: 14px;\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-bubble.ngx-slider-limit {\n    //   font-weight: bold;\n      color: orange;\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-tick {\n      width: 1px;\n      height: 10px;\n      margin-left: 4px;\n      border-radius: 0;\n      background: black;\n      top: -1px;\n    }\n  \n    .nbia-pixelSpacing-range-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected {\n      background: orange;\n    }\n  }\n\n  .pixelSpacing-input-box {\n    width: 70px;\n    margin-left: 20px;\n    margin-right: 10px;\n  }\n\n  .available-checkbox {\n    margin-top: 15px;\n    margin-bottom: 12px;\n}\n\n\n.nbia-pixelSpacing-range-note{\n  //  float: right;\n  padding-top: 0;\n  margin-top: 4px;\n  margin-bottom: 10px;\n  margin-left: 36px;\n  height: 20px;\n}\n\n.nbia-pixelSpacing-range-update-button{\n  float: right;\n  margin-right: 10px;\n//  margin-top: -3px;\n  margin-bottom: 10px;\n  height: 30px;\n  padding-top: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
